import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {AuthService} from './auth.service';
import {Auth, IAuth} from '../shared/auth';

@Injectable()
export class AlreadyLoggedInGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthService) {}

  canActivate() {
    return Observable.create((observer) => {
      this.authService.isLoggedIn().subscribe(
        (isLoggedIn: IAuth) => {
          const auth: IAuth = Auth.decode(sessionStorage.getItem('auth-credential'));

          if (isLoggedIn && auth) {
            this.router.navigate(['/']);
            observer.next(false);

          } else if (!auth || observer.isStopped) {
            observer.next(true);

          } else {
            this.authService.login(auth).subscribe(
              (isLogged: boolean) => {
                if (isLogged) {
                  this.router.navigate(['/']);
                  observer.next(false);
                } else {
                  observer.next(true);
                }
              },
              (err) => {
                observer.next(true);
              }
            );
          }
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/guard/already-logged-in.guard.ts